import { WarningDiamondIcon } from '@phosphor-icons/react'
import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/ui/icon'
import { Tooltip, useIsTruncated } from '@/components/ui/tooltip'
import { Typography } from '@/components/ui/typography'
import { MaintenanceRequest } from '@/models/features'

import * as S from '../maintenance-dashboard.styled'
import { getMaintenanceRequestObject } from '../maintenance-dashboard.utils'

// Note: minWidth 0 lets the tooltip's wrapper shrink with the text, so the ellipsis kicks in
// before the emergency badge gets pushed out of the cell.
const TOOLTIP_STYLE: CSSProperties = { minWidth: 0 }

interface RequestObjectCellProps {
  request: MaintenanceRequest
}

export const RequestObjectCell = ({ request }: RequestObjectCellProps) => {
  const { t } = useTranslation(['maintenance'])
  const { check, isTruncated, ref } = useIsTruncated<HTMLSpanElement>()
  const requestObject = getMaintenanceRequestObject(request, t)

  return (
    <S.CellWithAvatar>
      <Tooltip
        disabled={!isTruncated}
        style={TOOLTIP_STYLE}
        trigger={
          <S.TruncatedText ref={ref} onMouseEnter={check}>
            <Typography as="span" size="text-small" color="black800">
              {requestObject}
            </Typography>
          </S.TruncatedText>
        }
      >
        {requestObject}
      </Tooltip>
      {request.priority === 'Emergency' && (
        <Tooltip
          trigger={
            <S.UrgentBadge>
              <Icon icon={WarningDiamondIcon} size="1.4rem" color="white" weight="fill" />
            </S.UrgentBadge>
          }
        >
          {t('maintenance:requests.cells.emergencyRequest')}
        </Tooltip>
      )}
    </S.CellWithAvatar>
  )
}
